import styled from 'styled-components';

const Table = styled.table.attrs(() => ({
  cellPadding: 0,
  cellSpacing: 0,
}))`
  background-color: ${props => props.theme.background.background100};
  width: 100%;
`;

export default Table;
